<template>
  <div class="home view">
    <Header class="header"></Header>
    <div class="case layoutGrid">
      <div class="case__container">
        <router-link to="/cuberover" class="link link__cube">
          <p class="new-link case__bold">
            <span class="case__bold" id="link">CubeRover</span>
          </p>
        </router-link>

        <router-link to="/offbeat" class="link link__beat">
          <p class="new-link case__bold">
            <span class="case__bold" id="link">OffBeat</span>
          </p>
        </router-link>

        <router-link to="/fish" class="link link__fish">
          <p class="new-link case__bold">
            <span class="case__bold" id="link">The Fish Place</span>
          </p>
        </router-link>

        <router-link to="/radpiper" class="link link__rad">
          <p class="new-link p">
            <span class="p" id="link">RadPiper</span>
          </p>
        </router-link>

        <!-- <router-link to="/casual" class="link link__casual">
          <p class="new-link p">
            <span class="p" id="link">Business Casual</span>
          </p>
        </router-link>

        <router-link to="/drafter" class="link link__drafter">
          <p class="new-link p">
            <span class="p" id="link">Project Drafter</span>
          </p>
        </router-link> -->

        <router-link to="/hyperloop" class="link link__hyperloop">
          <p class="new-link p">
            <span class="p" id="link">Carnegie Mellon Hyperloop</span>
          </p>
        </router-link>
        <router-link to="/vis" class="link link__vis">
          <p class="new-link p">
            <span class="p" id="link">Visualization</span>
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue";

export default {
  name: "home",
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.case {
  padding-top: 6rem;
  height: 100vh;
  text-align: center;
  align-items: center;

  &__container {
    grid-column: 2 / 6;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.link {
  text-decoration: none;
  text-align: center;
  padding: 0.6rem 1.2rem 2rem 1.2rem;
}

.new-link {
  width: max-content;
  max-width: 100%;
}
.link:hover p.new-link span {
  display: none;
}
.link__cube:hover p.new-link:after {
  content: "User experience & interface design for a lunar rover";
}
.link__beat:hover p.new-link:after {
  content: "Service design for amateur musicians";
}
.link__rad:hover p.new-link:after {
  content: "User experience design for nuclear robotics";
}
.link__casual:hover p.new-link:after {
  content: "App to connect businesses with students";
}
.link__drafter:hover p.new-link:after {
  content: "User experience design for an AR CAD program";
}
.link__hyperloop:hover p.new-link:after {
  content: "VR storytelling and experience design";
}
.link__vis:hover p.new-link:after {
  content: "Sketching rendering and animating ideas";
}
.link__fish:hover p.new-link:after {
  content: "Designing an intervention to create sustainable fish";
}
</style>
